import {Tooltip} from "@mui/material";
import "../components/contactUs/ContactUs/contactUs.css";
import { connect } from 'react-redux';
import withRouterCompat from "../objects/CommonUse/with_router_compat";
//import {InputCompletedContext} from '../objects/Context/input_completed_context';
import ContactUsMain from '../components/contactUs/contact_us_main';
import GameFeedbackPage from "../components/contactUs/game_feedback_page";
import CommentModal from '../components/shared-components/comment_modal';
import Footer from "./footer";
import {Link} from "react-router-dom";
import React from 'react';
import LinkTab from "../components/shared-components/link_tab";
import { setHeadersForFetch } from "../objects/CommonUse/set_headers_for_fetch";
import {buildUrl } from '../objects/CommonUse/build_URL';
import PlayerCommentDisplay from '../components/contactUs/player_comment_display';
import TeacherParentSignup from "../components/contactUs/teacher_parent_signup";
import Config from '../config';
import tooltipCommentIconText from "./Text/tooltip_text";
import updateSessionTokenStorage from "./Objects/update_session_token_storage";
import setTempTokenForFetch from "../objects/CommonUse/set_temp_token_for_fetch";


// mapStateToProps: pick the Redux state your component needs
const mapStateToProps = (state) => ({
    gameInfo: state,
});

class ContactUs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            gameInfo: {},
        }
               
  

    this.openCommentModal = this.openCommentModal.bind(this);
    this.closeCommentModal = this.closeCommentModal.bind(this);

     this.state = {
        inputArr: [
            {
                completed: false,
                selected: true
            },
            {
                completed: false,
                selected: false
            },
            {
                completed: false,
                selected: false
            },
            {
                completed: false,
                selected: false
            },
          
        ],
        commentIcon: "./assets/ContactUs/pencilPaper.png",
        commentModalOpen: false,
        fromProcessName: "AboutPage",
        screenSize: sessionStorage.getItem("GameScreenSize"),
        gameInfo: {},
        environment: Config.dataURL.currentEnv,
        subProcess: "ContactUsMain",
    };
    switch(props.selected) {
        case "contactUsMain":
            this.inputSelected(0);
            break;
        case "teacherParentSignup":
            this.inputSelected(1);
            break;
        case "gameFeedback":
            this.inputSelected(2);
            break;
        case "playerComments":
            this.inputSelected(3);
            break;
        default:
            break;        
    }
    this.selected = "";
    this.getUsername();
}

getUsername(){
    this.username = sessionStorage.getItem("username");
}

    onNavigate = (path) => {
        const { navigate, location } = this.props;

        const targetPath = `/${path}`;
        // Only navigate if we aren’t already there
        if (location.pathname !== targetPath) {
            navigate(`/${path}`, { replace: true });
        }
    };

    render(){
        if (this.selected !== this.props.selected && this.username){
            updateSessionTokenStorage(this.props.selected);
            this.selected = this.props.selected;
        }
    return <>
            <span className="container m-0 p-0">
                <span className="row w-100 mx-0">
                    <div className="col-sm-2 mt-4">
                        <div>
                            <img  className="train-track-img" src={'./assets/ExtraCredit.png'} 
                                alt="MoneyTrain"/>
                        </div>   
                    </div>
                    
               
                    {this.props.selected === "contactUsMain" ? 
                            <ContactUsMain
                                goBack = {() => this.goToHomePage()}
                                processError = {(errorObj) => this.processErrorReturn(errorObj)}
                                /> 
                    : 
                        <span/>
                    }

                    
                    {this.props.selected === "teacherParentSignup" ? 
                            <TeacherParentSignup
                                goBack = {() => this.goToHomePage()}
                                processError = {(errorObj) => this.processErrorReturn(errorObj)}
                                /> 
                    : 
                        <span/>
                    }

                    {this.props.selected === "gameFeedback" ?
                            <GameFeedbackPage
                                username={this.username}
                                goBack = {() => this.goToHomePage()}
                                processError = {(errorObj) => this.processErrorReturn(errorObj)}
                            />
                    :
                       <span/>
                    }

                    {this.props.selected === "playerComments" ?
                            <PlayerCommentDisplay
                                username={this.username}
                                goBack = {() => this.goToHomePage()}
                                processError = {(errorObj) => this.processErrorReturn(errorObj)}
                            />
                    :
                       <span/>
                    }

                    {this.username === null ?
                        null
                    :
                        <div>
                            <Tooltip title={tooltipCommentIconText} arrow>
                                <img src={this.state.commentIcon} 
                                    className={this.commentIconClass} alt="comment"
                                    onClick={this.openCommentModal}/>
                            </Tooltip>
                        </div>
                    }
                
                    {this.state.commentModalOpen ?
                        <CommentModal modalOpen={this.state.commentModalOpen} 
                            onClose={() => this.closeCommentModal()}
                            gamePart={this.state.fromProcessName}
                            processName={this.props.selected}
                            gameInfo = {() => this.getGameInfo()}
                            processError = {(errorObj) => this.processErrorReturn(errorObj)}
                        />
                    :
                        null
                    }
                            
                    <div className="col-sm-2 mt-4">   
                                                                                  
                        <Link to="/contact-us-main" onClick={() => this.handleClick(0)}>    
                            <LinkTab inputArr={this.state.inputArr[0]} name="Contact Us" validToComplete="true" 
                            />
                        </Link>  
                        <Link to="/teacher-parent-signup" onClick={() => this.handleClick(1)}>    
                            <LinkTab inputArr={this.state.inputArr[1]} name="Teacher Parent Signup" validToComplete="true" 
                                />
                        </Link>  
                        {this.username !== null ?
                            <Link to="/game-feedback" onClick={() => this.handleClick(2)}>    
                                <LinkTab inputArr={this.state.inputArr[2]} name="Game Feedback" validToComplete="true" 
                                  />
                            </Link>    
                        
                        :
                            <LinkTab inputArr={this.state.inputArr[2]} 
                                    name="Game Feedback" 
                                    tooltip="true"
                                    tooltipText="Click on the person icon (in the header area)
                                        and logon to Provide Game feedback."
                            />
                        } 
                        {this.username !== null ?
                            <Link to="/player-comments" onClick={() => this.handleClick(3)}>
                                <LinkTab inputArr={this.state.inputArr[3]} 
                                    name="Review My Game Comments" validToComplete="true" 
                                />
                            </Link>
                        :
                            <LinkTab inputArr={this.state.inputArr[3]} 
                                    name="Review My Game Comments" 
                                    tooltip="true"
                                    tooltipText="Click on the person icon (in the header area)
                                    and logon to Review Game Comments."
                            />
                        }        
                        {( this.state.screenSize === "zoom") &&
                            <Footer 
                                screenSize={this.state.screenSize}
                            />
                    }        
                    </div>    
    {/*
             {process.env.NODE_ENV === 'development' && (
                        <div className="breakpoint-indicator" />
                        )}
    */}
            </span>
       </span>             
    </>
}

componentDidMount(){
    this._isMounted = true;
    const gameInfo = this.props.gameInfo;
    this.setState({gameInfo: gameInfo});
    if (this.state.screenSize === "ipad" ||
        this.state.screenSize === "zoom"
    ){
        this.commentIconClass = "comment-icon-position comment-img";
    }else{
        this.commentIconClass = "contact-us-comment-icon-position comment-img"; 
    }
}

inputSelected = (inputID) => {
    let inputArr = this.state.inputArr;
    for (const input of inputArr) {
        input.selected = false;
     }
    inputArr[inputID].selected = true;
    if (this._isMounted === true){
        this.setState({inputArr: inputArr});
    }  
};

openCommentModal(){
    this.setState({commentModalOpen: true});
}

closeCommentModal(){
    this.setState({commentModalOpen: false});
}

handleClick = index => {
    this.inputSelected(index);
}

getGameInfo()
{
    return this.state.gameInfo;
}

goToHomePage(){
    let newProcess = "";
    if (!this.state.gameInfo.prevProcess ||
        this.state.gameInfo.prevProcess === ""){
            newProcess = "/";
    }else{
        newProcess = this.state.gameInfo.prevProcess;
    }
    this.onNavigate(newProcess);
}


processErrorReturn(errorObj){
    this.addRecordToLogfile(errorObj);
    if (!errorObj.silentAlert || errorObj.silentAlert === false){
        alert ("Uh oh!  Something unexpected has occurred " +
            "error has been logged and will be addressed. " +
            "For now click OK, then return to the process " +
            "where you were and try again.");
        this.onNavigate("");
    }
}

addRecordToLogfile(errorObj){
    let urlParm = "";
    let headers = "";
    if (errorObj.errorObject.userName === "NotSignedIn"){
        headers = setTempTokenForFetch("DemoId", "demo!");
        urlParm = "?tokenType=TempToken"
    }else{
        headers=setHeadersForFetch();
    }
    if (errorObj.status === 250){
        errorObj.message = "No record found";
    }
    let subProcess = "";  
    if (!errorObj.subProcess){
        subProcess = "unknown"
    }else{
        subProcess = errorObj.subProcess;
    }
    if (!errorObj.errorObject){
        errorObj.errorObject = {};
    }
    const logFileBody =  {
        mainProcess: "About",
        subProcess: subProcess,
        function: errorObj.function,
        status: errorObj.status,
        message: errorObj.message,
        errorObj: errorObj.errorObject
    }
    console.log("logFileBody is: ", logFileBody)
    const uri = buildUrl(this.state.environment, "saveLogFile", urlParm);
    fetch (uri,  
        {method:'POST',
            headers: headers,
            body: JSON.stringify(logFileBody)
        })
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        console.log("logfile create was successful");
                    }else{
                        console.log("Response from save log file not valid!" +
                         " status is: ", output.statusCode,
                         " message is: ", output.body);
                        alert ("Response from save log file not valid!");
                           
                    }
            });
          
        }
    });
  
}

}
export default connect(mapStateToProps)(withRouterCompat(ContactUs));